export enum DateFormats {
  'ShortDate' = 'MM/dd/yyyy',
  'LongDate' = 'MMM dd yyyy',
  'DayOfWeekDayOfMonth' = 'eeee, MMMM do',
}
